
const CollectionsByUserUuid_query = `query($userUuid: String!){
  collectionsByUseruuid(userUuid: $userUuid){
    collectionId
    contentType{
      model
    }
    userId
    {
      username
    }
    objectCardInfo
    {
      ownerInfo
      {
        id
        userUuid
        firstName
        lastName
        username
        avatarFileName
        listings
        soldToys
        ratingNo
        ratingCount
        dateJoined
        isLoggedInUserFollowing
      
      }
      title
      uuid
      orignalPrice
      sellingPrice
      category
      shareUrl
      image
      commentNo
      likeNo
      shareNo
      content
      isLiked
      comments{
        uuid
        userId
        {
          username
          avatarFileName
          isLoggedInUserFollowing
        }
        title
        content
        objectId
        contentType
        likeNo
        isLiked
        replies{
          uuid
          userId
          {
            username
            avatarFileName
            isLoggedInUserFollowing
          }
          content
          objectCommentId
          contentType
          likeNo
          isLiked
          createBy
          createDate
          updateDate
          updateBy
        }
        createBy
        createDate
        updateDate
        updateBy
      }      
    }
  }     
}`;

const CreateCollection_mutate = `
    mutation createCollection(
      $objectId: Int!,
      $contentType: String!,      
      
      ) {
      createCollection(
        objectId: $objectId,
        contentType: $contentType,
        
        ) {
        
        collection{
          collectionId
        }
     }
    }`;

const DeleteCollection_mutate = `
    mutation deleteCollection(
      $objectId: Int!,
      $contentType: String!,    
      
      ) {
      deleteCollection(
        objectId: $objectId,
        contentType: $contentType,        
        ) {
        
        response
      }
    }
`;

module.exports = {
  COLLECTIONS_BY_USER_UUID: CollectionsByUserUuid_query,
  CREATE_COLLECTION_MUTATION: CreateCollection_mutate,
  DELETE_COLLECTION_MUTATION: DeleteCollection_mutate
 
}
